<template>
  <div id="app">
    <v-footer color="primary lighten-1" padless>
      <v-row justify="center" no-gutters>
        <v-col
          class="primary lighten-2 py-4 text-center white--color"
          cols="12"
        >
          <strong class="white--text">Share page to social:</strong>
          <socialSharing />
        </v-col>
        <v-btn
          v-for="link in ogLinks"
          :key="link.title"
          color="white"
          text
          rounded
          class="my-2"
          :href="link.link"
          :id="link.id"
        >
          {{ link.title }}
        </v-btn>

        <v-col class="primary lighten-2 py-4 text-center white--text" cols="12">
          <v-btn
            v-for="(social, index) in socialItems"
            :key="index"
            class="mx-4"
            dark
            icon
            :href="social.link"
            :id="social.id"
          >
            <v-icon size="18px">{{ social.icon }}</v-icon>
          </v-btn>
          {{ new Date().getFullYear() }} — <strong>Olympian Guru</strong>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import socialSharing from "./social_sharing.vue";

export default {
  components: { socialSharing },
  data() {
    return {
      socialItems: [
        {
          icon: "fab fa-facebook",
          link: "https://www.facebook.com/OlympianGuru/",
          id: "facebook_social"
        },
        {
          icon: "fab fa-twitter",
          link: "https://twitter.com/OlympianGuru",
          id: "twitter_social"
        },
        {
          icon: "fab fa-telegram",
          link: "https://t.me/OlympianGuru",
          id: "telegram_social"
        },
        {
          icon: "fas fa-envelope",
          link: "mailto:olympianguru@gmail.com",
          id: "envelope_social"
        }
        //  { icon: "fab fa-instagram", link: "" },
        //  { icon: "fab fa-linkedin", link: "" },
        //  { icon: "fab fa-google-plus", link: "" },
      ],
      ogLinks: [
        { title: "Home", link: "https://olympian.guru", id: "og_home" },
        { title: "Services", link: "https://olympian.guru", id: "og_services" },
        { title: "About Us", link: "https://olympian.guru", id: "og_about" }
        //  { title: 'Contact Us:' },
      ]
    };
  }
};
</script>
